var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard" },
    [
      _c("div", { staticClass: "main-logo" }, [
        _vm._v("\n    Neighbor Dashboard\n  "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            display: "table",
            width: "100%",
            "vertical-align": "center",
            "margin-top": "2%",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "search-form",
              staticStyle: {
                display: "table-cell",
                "vertical-align": "center",
                "text-align": "center",
                padding: "0 25%",
              },
            },
            [
              _c(
                "div",
                {
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.load.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "vertical-align": "middle",
                        "text-align": "center",
                      },
                      attrs: {
                        placeholder:
                          "Search by e-mail, Mac Address, Serial Number, Order ID or PLC uuid/gid",
                        size: "small",
                      },
                      on: {
                        input: function ($event) {
                          _vm.searchPatternError = false
                        },
                      },
                      model: {
                        value: _vm.searchCriteria,
                        callback: function ($$v) {
                          _vm.searchCriteria =
                            typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "searchCriteria",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-input__icon el-icon-search",
                        staticStyle: { "line-height": "25px" },
                        attrs: { slot: "prefix" },
                        slot: "prefix",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { staticClass: "tip-message", attrs: { span: 24 } },
                [
                  _vm.searchType === "Unknown"
                    ? _c(
                        "span",
                        { class: { warning: _vm.searchPatternError } },
                        [
                          _vm._v(
                            "Search by e-mail, Mac Address, Serial Number, Order ID or PLC uuid/gid"
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: {
                    display: "inline-block",
                    "vertical-align": "middle",
                    "text-align": "center",
                  },
                  attrs: { type: "primary" },
                  on: { click: _vm.load },
                },
                [_c("span", [_vm._v("Search")])]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.openDeviceSelectorModal
        ? _c("DeviceSelector", {
            attrs: {
              devices: _vm.deviceMatches,
              profile: _vm.deviceProfile,
              open: _vm.openDeviceSelectorModal,
            },
            on: {
              "update:open": function ($event) {
                _vm.openDeviceSelectorModal = $event
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openProfileCreatorModal
        ? _c("ProfileCreator", {
            attrs: {
              "device-id": _vm.searchCriteria,
              open: _vm.openProfileCreatorModal,
            },
            on: {
              "update:open": function ($event) {
                _vm.openProfileCreatorModal = $event
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.result
        ? _c("RingSolutionsRedirectDialog", {
            attrs: {
              device: _vm.result,
              open: _vm.openRedirectToRingSolutions,
            },
            on: {
              "update:open": function ($event) {
                _vm.openRedirectToRingSolutions = $event
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.detailsVisible
        ? _c("OrderDetails", {
            attrs: {
              visible: _vm.detailsVisible,
              "order-number": _vm.order_id,
            },
            on: {
              "update:visible": function ($event) {
                _vm.detailsVisible = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }